import React from "react";
import { NextSeo } from "next-seo";
import { wrapper } from "../../src/store";
import { END } from "redux-saga";
import dynamic from "next/dynamic";

import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { handleImageLink } from "@/helpers/functions";
import {
  getPageData,
  getSettings,
  getSectionData,
  getSocials,
  getClients,
  getContactSection,
  getServices,
} from "@/store/actions";

const Header = dynamic(() => import("@/components/header/Index"), {
  ssr: false,
});

const Footer = dynamic(() => import("@/components/footer/Index"), {
  ssr: false,
});

const JumbotronSection = dynamic(() => import("@/components/jumbotron/Index"), {
  ssr: false,
});

const SubscribeSection = dynamic(
  () => import("@/components/subscribe-section/Index"),
  {
    ssr: false,
  },
);

const ClientsSection = dynamic(
  () => import("@/components/clients-section/Index"),
  {
    ssr: false,
  },
);

const ServicesPageContent = dynamic(
  () => import("@/components/services-page-content-new/Index"),
  {
    ssr: false,
  },
);

const Home = () => {
  const { locale, asPath } = useRouter();
  const { sectionData, settings } = useSelector((state) => state.settings);

  return (
    <>
      <NextSeo
        title={`${sectionData?.metaTitle?.[locale]} | ${settings?.appName?.[locale]}`}
        description={sectionData?.metaDescription?.[locale]}
        openGraph={{
          title: sectionData?.metaTitle?.[locale],
          description: sectionData?.metaDescription?.[locale],
        }}
        // canonical={
        //   typeof window !== "undefined"
        //     ? window.location.href
        //     : `${process.env.NEXT_PUBLIC_SITE_URL}/${asPath}`
        // }
        twitter={{
          cardType: "summary_large_image",
          handle: "@handle",
          site: "@site",
          title: sectionData?.metaTitle?.[locale],
          description: sectionData?.metaDescription?.[locale],
          image: handleImageLink(settings?.appLogo),
        }}
      />
      <Header innerPages />
      <JumbotronSection
        title={sectionData?.metaTitle?.[locale] || ""}
        id="services-page"
      />
      <ServicesPageContent />
      <SubscribeSection />
      <ClientsSection />
      <Footer />
    </>
  );
};

export const getStaticProps = wrapper.getStaticProps((store) => {
  return async () => {
    store.dispatch(getPageData({ cookies: {}, slug: "home" }));
    store.dispatch(
      getSectionData({ cookies: {}, pageSlug: "seo", sectionSlug: "services" }),
    );
    store.dispatch(
      getSettings({
        cookies: {},
      }),
    );
    store.dispatch(getServices({ cookies: {} }));
    store.dispatch(getSocials({ cookies: {} }));
    store.dispatch(getClients({ cookies: {} }));
    store.dispatch(getContactSection({ cookies: {} }));

    store.dispatch(END);
    await store.sagaTask.toPromise();

    // const state = store.getState();
    // const pageData = state?.settings?.pageData;
    // const sectionData = state?.settings?.sectionData;

    // // Redirect to 404 if no data found
    // if (
    //   !pageData ||
    //   Object.keys(pageData).length === 0 ||
    //   !sectionData ||
    //   Object.keys(sectionData).length === 0
    // ) {
    //   return {
    //     notFound: true,
    //   };
    // }

    return {
      props: {},
      revalidate: 1,
    };
  };
});

export default Home;
